<template>
  <div>
    <InvoiceActionsContextMenu
      :invoice="invoice"
      :visible-actions="visibleActions"
      :tippy-options="tippyOptions"
      hide-membership-savings-toggle
    />
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { EventBus } from "@/lib/event_bus";

import InvoiceActionsContextMenu from "@/components/Invoice/InvoiceActionsContextMenu.vue";
import type { Invoice } from "@/typings/invoice";
import type { TippyOptions } from "@/typings/ui";
import { InvoiceAction } from "@/typings/ui";

defineProps<{
  invoice: Invoice;
}>();

const tippyOptions: TippyOptions = {
  theme: "light revenue-context-menu tooltip-standard-size"
};

const visibleActions: InvoiceAction[] = [InvoiceAction.Resubmit];

function refreshDatatable() {
  EventBus.$emit("refresh-datatable");
}

onMounted(() => {
  EventBus.$on("invoice-cancelled", refreshDatatable);
  EventBus.$on("invoice-resubmitted", refreshDatatable);
});

onBeforeUnmount(() => {
  EventBus.$off("invoice-cancelled", refreshDatatable);
  EventBus.$off("invoice-resubmitted", refreshDatatable);
});
</script>

<style lang="scss">
.tippy-tooltip.revenue-context-menu-theme {
  .tippy-content {
    background-color: var(--white) !important;
  }
}
</style>
